import { requireAuth } from "../guards/auth.guard";
import { RouteRecordRaw } from "vue-router";
// Base
import TaskView from "@/views/v2/tasks/index.vue";
// Mortality Check
import MortalityCheck from "@/views/v2/tasks/mortality/index.vue";
import MortalityCheckOverview from "@/views/v2/tasks/mortality/OverviewView.vue"
import MortalityCheckGroupView from "@/views/v2/tasks/mortality/GroupView.vue"
import MortalityCheckTankView from "@/views/v2/tasks/mortality/TankView.vue"
// Fish Reconciliation
import FishReconciliation from "@/views/v2/tasks/fish-reconciliation/index.vue";
import FishReconciliationOverview from "@/views/v2/tasks/fish-reconciliation/OverviewView.vue"
import FishReconciliationTankView from "@/views/v2/tasks/fish-reconciliation/TankView.vue"
import FishReconciliationGroupView from "@/views/v2/tasks/fish-reconciliation/GroupView.vue"
// Environmental Check
import EnvironmentalCheck from "@/views/v2/tasks/environmental-check/EnvironmentalCheckTaskPage.vue";
// Environmental Modifier
import EnvironmentalModifier from "@/views/v2/tasks/environmental-modifier/EnvironmentalModifierTaskPage.vue"
// Fish Transfer
import AnimalTransfer from "@/views/v2/tasks/animal-transfer/AnimalTransferTaskPage.vue";
// Pre challenge
import PreChallenge from "@/views/v2/tasks/pre-challenge/PreChallengeTaskPage.vue";
// Fish Import
import FishImport from "@/views/v2/tasks/fish-import/FishImportTaskPage.vue"
import FishImportImportsView from "@/views/v2/tasks/fish-import/ImportsView.vue";
import FishImportOverviewView from "@/views/v2/tasks/fish-import/OverviewView.vue";
// Vaccination
import Vaccination from "@/views/v2/tasks/vaccination/index.vue";
import VaccinationConfigurationView from "@/views/v2/tasks/vaccination/ConfigurationsView.vue";
import VaccinationsView from "@/views/v2/tasks/vaccination/VaccinationsView.vue";
import VaccinationWeightsView from "@/views/v2/tasks/vaccination/WeightsView.vue";
import VaccinationOverviewView from "@/views/v2/tasks/vaccination/OverviewView.vue";
import EquipmentView from "@/views/v2/equipment/index.vue"
// Challenge
import Challenge from "@/views/v2/tasks/challenge/index.vue"
import ChallengeConfigurationView from "@/views/v2/tasks/challenge/ConfigurationsView.vue";
import ChallengesView from "@/views/v2/tasks/challenge/ChallengesView.vue";
import ChallengeWeightsView from "@/views/v2/tasks/challenge/WeightsView.vue";
import ChallengeOverviewView from "@/views/v2/tasks/challenge/OverviewView.vue";

export const TasksRoutes: Array<RouteRecordRaw> = [
  {
    path: "/tasks/:key",
    name: "LoadTask",
    component: TaskView,
    beforeEnter: requireAuth,
  },
  {
    path: "/tasks/vaccination/:key",
    name: "Vaccination",
    component: Vaccination,
    beforeEnter: requireAuth,
    meta: {
      title: "Vaccination Task"
    },
    children: [
      {
        path: "",
        name: "VaccineConfigurations",
        component: VaccinationConfigurationView,
        props: true,
      },
      {
        path: "vaccinations",
        name: "VaccineVaccinations",
        component: VaccinationsView,
      },
      {
        path: "weights",
        name: "VaccineWeights",
        component: VaccinationWeightsView,
      },
      {
        path: "overview",
        name: "VaccineOverview",
        component: VaccinationOverviewView,
      },
      {
        path: "equipment",
        name: "VaccinationEquipmentView",
        component: EquipmentView,
      }
    ],
  },
  {
    path: "/tasks/mortality-check/:key",
    name: "MortalityCheck",
    component: MortalityCheck,
    beforeEnter: requireAuth,
    meta: {
      title: "Mortality Check Task"
    },
    children: [
      {
        path: "",
        name: "MortalityCheckOverview",
        component: MortalityCheckOverview,
      },
      {
        path: "tank-view/:tankKey",
        name: "MortalityCheckTankView",
        component: MortalityCheckTankView,
      },
      {
        path: "group-view/:groupKey",
        name: "MortalityCheckGroupView",
        component: MortalityCheckGroupView,
      }
    ]
  },
  {
    path: "/tasks/fish-reconciliation/:key",
    name: "FishReconciliation",
    component: FishReconciliation,
    beforeEnter: requireAuth,
    meta: {
      title: "Fish Reconciliation Task"
    },
    children: [
      {
        path: "",
        name: "FishReconciliationOverview",
        component: FishReconciliationOverview,
      },
      {
        path: "tank-view/:tankKey",
        name: "FishReconciliationTankView",
        component: FishReconciliationTankView,
      },
      {
        path: "group-view/:groupKey",
        name: "FishReconciliationGroupView",
        component: FishReconciliationGroupView,
      }
    ]
  },
  {
    path: "/tasks/environmental-check/:key",
    name: "EnvironmentalCheck",
    component: EnvironmentalCheck,
    beforeEnter: requireAuth,
    meta: {
      title: "Environment Check Task"
    },
  },
  {
    path: "/tasks/challenge/:key",
    name: "Challenge",
    component: Challenge,
    beforeEnter: requireAuth,
    meta: {
      title: "Challenge Task"
    },
    children: [
      {
        path: "",
        name: "ChallengeConfigurations",
        component: ChallengeConfigurationView,
        props: true,
      },
      {
        path: "challenges",
        name: "ChallengeChallenges",
        component: ChallengesView,
      },
      {
        path: "weights",
        name: "ChallengeWeights",
        component: ChallengeWeightsView,
      },
      {
        path: "overview",
        name: "ChallengeOverview",
        component: ChallengeOverviewView,
      },
      {
        path: "equipment",
        name: "ChallengeEquipmentView",
        component: EquipmentView,
      }
    ],
  },
  {
    path: "/tasks/pre-challenge/:key",
    name: "PreChallenge",
    component: PreChallenge,
    beforeEnter: requireAuth,
    meta: {
      title: "Dilutions Task"
    },
  },
  {
    path: "/tasks/animal-transfer/:key",
    name: "AnimalTransfer",
    component: AnimalTransfer,
    beforeEnter: requireAuth,
    meta: {
      title: "Animal Transfer Task"
    },
  },
  {
    path: "/tasks/fish-import/:key",
    name: "FishImport",
    component: FishImport,
    beforeEnter: requireAuth,
    meta: {
      title: "Fish Import Task"
    },
    children: [
      {
        path: "",
        name: "FishImportImports",
        component: FishImportImportsView,
      },
      {
        path: "overview",
        name: "FishImportOverview",
        component: FishImportOverviewView,
      },
    ],
  },
  {
    path: "/tasks/environmental-modifier/:key",
    name: "EnvironmentalModifier",
    component: EnvironmentalModifier,
    beforeEnter: requireAuth,
    meta: {
      title: "Environmental Modifier Task"
    },
  },
];
